import { render, staticRenderFns } from "./TextImageBlock.vue?vue&type=template&id=2a6d34c0&scoped=true"
import script from "./TextImageBlock.vue?vue&type=script&lang=ts"
export * from "./TextImageBlock.vue?vue&type=script&lang=ts"
import style0 from "./TextImageBlock.vue?vue&type=style&index=0&id=2a6d34c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6d34c0",
  null
  
)

export default component.exports